import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import HeroSection from './components/HeroSection';
import ServiceCardsSection from './components/ServiceCardsSection';
import AboutPreviewSection from './components/AboutPreviewSection';
import AdvantagesSection from './components/AdvantagesSection';
import StatsSection from './components/StatsSection';
import ProductShowcaseSection from './components/ProductShowcaseSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaBannerSection from './components/CtaBannerSection';

export default function HomePage() {
  useSEO({
    title: '康永生技｜保健食品 ODM OEM 代工服務專家',
    description: '康永生技提供專業保健食品與生技產品 ODM、OEM 代工服務，從配方研發、劑型設計到包裝設計一站到位，HACCP 認證工廠，250+ 品牌信賴選擇。',
    keywords: '康永生技,ODM代工,OEM代工,保健食品代工,生技產品代工,保健食品製造,配方研發,包裝設計',
    lang: 'zh-TW',
    canonicalPath: '/',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebSite" />
      <SEOJsonLd
        type="Organization"
        pageTitle="康永生技｜保健食品 ODM OEM 代工服務專家"
        pageDescription="康永生技提供專業保健食品與生技產品 ODM、OEM 代工服務，從配方研發到包裝設計一站到位。"
        pageUrl="https://kangyong.com/"
      />
      <HeroSection />
      <ServiceCardsSection />
      <AboutPreviewSection />
      <StatsSection />
      <AdvantagesSection />
      <ProductShowcaseSection />
      <ProcessSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaBannerSection />
    </Layout>
  );
}
